import { DialogV2, Inset, Stack, makeDialog } from '@cast/design-system';

import { useIsCustomMetricsEnabled } from '../../../_hooks/permissions/useIsCustomMetricsEnabled';
import { ChartSectionTrialOverlay } from '../../../_components/ChartSection/ChartSectionTrialOverlay';
import { CpuChartSection } from '../../../_components/ChartSection/ResourceChartSections/CpuChartSection';
import { CpuPredictionChartSection } from '../../../_components/ChartSection/ResourceChartSections/CpuPredictionChartSection';
import { JvmChartSection } from '../../../_components/ChartSection/ResourceChartSections/JvmChartSection';
import { MemoryChartSection } from '../../../_components/ChartSection/ResourceChartSections/MemoryChartSection';
import { WorkloadSelectedContainerProvider } from '../../../_components/ChartSection/_hooks/useWorkloadSelectedContainer';
import { WorkloadDetailsProvider } from '../../../workload-details/WorkloadDetailsProvider';
type WorkloadQuickViewChartsDialogContentProps = {
  workloadId: string;
};

const WorkloadQuickViewChartsDialogContent = ({
  workloadId,
}: WorkloadQuickViewChartsDialogContentProps) => {
  const isCustomMetricsEnabled = useIsCustomMetricsEnabled();

  return (
    <WorkloadDetailsProvider workloadId={workloadId}>
      <WorkloadSelectedContainerProvider>
        <DialogV2
          testId="workload-quick-view-charts-dialog"
          title="Quick view charts"
          slotProps={{
            // DialogV2 default is 560px; charts need more horizontal space
            root: { size: 940 },
          }}
        >
          <Inset pb={24}>
            <Stack flex={1} overflow="hidden">
              <ChartSectionTrialOverlay>
                <CpuChartSection />
                <CpuPredictionChartSection />
                <MemoryChartSection />
                {isCustomMetricsEnabled && <JvmChartSection />}
              </ChartSectionTrialOverlay>
            </Stack>
          </Inset>
        </DialogV2>
      </WorkloadSelectedContainerProvider>
    </WorkloadDetailsProvider>
  );
};

export const useWorkloadQuickViewChartsDialog = makeDialog(
  WorkloadQuickViewChartsDialogContent,
  { closeOnOverlayClick: true }
);
